import { render } from "./AI.vue?vue&type=template&id=159f0c8e&scoped=true"
import script from "./AI.vue?vue&type=script&lang=js"
export * from "./AI.vue?vue&type=script&lang=js"

import "./AI.vue?vue&type=style&index=0&id=159f0c8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159f0c8e"]])

export default __exports__